import React, { ReactNode } from 'react';
import AntdModal from 'antd/lib/modal';

/**
 * {@docCategory ConfirmModal}
 */
export interface ConfirmModalProps {
   /**
    * The title to display.
    */
   title: ReactNode;

   /**
    * The content.
    */
   content: ReactNode;

   /**
    * Sets the OK button to be a danger style.
    * @defaultvalue false
    */
   danger?: boolean;

   /**
    * Used to customize the OK button text.
    * @defaultvalue OK
    */
   okText?: ReactNode;

   /**
    * Used to customize the Cancel button text.
    * @defaultvalue Cancel
    */
   cancelText?: ReactNode;

   /**
    * Callback called when the user presses the OK button or presses enter.
    */
   onOk?: () => void;

   /**
    * Callback called when the user presses the Cancel button or hits escape.
    */
   onCancel?: () => void;
}

export class ConfirmModal {
   static show(props: ConfirmModalProps) {
      const okButtonProps = props.danger === undefined || !props.danger ? undefined : { danger: true };

      AntdModal.confirm({
                           title: props.title,
                           content: props.content,
                           okText: props.okText,
                           okButtonProps: okButtonProps,
                           cancelText: props.cancelText,
                           onOk: props.onOk,
                           onCancel: props.onCancel,
                           autoFocusButton: 'cancel'
                        });
   }
}
